export const ItemTypes = {
    FIELD: 'field',
}